import { Link } from 'react-router-dom';

const mono = { fontFamily: 'IBM Plex Mono, monospace' };

/**
 * Site-wide footer with the About / Contact / Privacy / Terms links. Rendered
 * by Layout on every public page so the links are in the DOM for signed-out
 * visitors and crawlers (AdSense review requires the policies be discoverable).
 */
const SiteFooter = () => (
  <footer
    className="border-t border-[#E4E1D9] mt-16 px-6 md:px-12 py-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[11px] uppercase tracking-[0.2em] text-[#6B6A68]"
    style={mono}
    data-testid="site-footer"
  >
    <nav className="flex flex-wrap gap-x-6 gap-y-2">
      <Link to="/about" className="hover:text-[#1A1A1A]">About</Link>
      <Link to="/contact" className="hover:text-[#1A1A1A]">Contact</Link>
      <Link to="/privacy" className="hover:text-[#1A1A1A]">Privacy Policy</Link>
      <Link to="/terms" className="hover:text-[#1A1A1A]">Terms</Link>
    </nav>
    <span className="text-[#9A9A98]">© {new Date().getFullYear()} North of Six Club</span>
  </footer>
);

export default SiteFooter;
